module.exports = __webpack_public_path__ + "static/img/OOSH_016.13cfda9.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/photos/OOSH_016.jpg
// module id = Lray
// module chunks = 170